import React from 'react';
import { motion } from 'framer-motion';

const BookingConsentModal = ({ advisorName, onShareAndBook, onBookWithoutSharing, onClose }) => (
  <div
    className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40"
    role="dialog"
    aria-modal="true"
    aria-labelledby="booking-consent-title"
  >
    <motion.div
      className="surface-panel max-w-md w-full p-6"
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, ease: 'easeOut' }}
    >
      <h2 id="booking-consent-title" className="font-display text-h2 text-ink mb-3">
        Share your financial snapshot?
      </h2>
      <p className="text-body text-ink-muted mb-6">
        To help {advisorName} prepare for your call, Aura can share a read-only summary of your
        goals and cashflow. No account details or transactions are shared.
      </p>
      <div className="flex flex-col sm:flex-row gap-3">
        <button type="button" onClick={onShareAndBook} className="btn-primary flex-1">
          Share &amp; Book
        </button>
        <button type="button" onClick={onBookWithoutSharing} className="btn-secondary flex-1">
          Book without sharing
        </button>
      </div>
      <button
        type="button"
        onClick={onClose}
        className="btn-ghost w-full mt-3"
      >
        Cancel
      </button>
    </motion.div>
  </div>
);

export default BookingConsentModal;
